import React, { useState, useRef } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import LaddaButton from "../../buttons/laddaButton";
import { callActionApiAsync, checkImportRegistrationNumber } from "../../../services/apiService";

const ForeignTradeVerificationModal = ({
  open,
  handleClose,
  onConfirm,
  onCancel,
  onError,
  yesNo = false,
  data,
  isEdit
}) => {
  const [loading, setLoading] = useState(false);
  const toastShownRef = useRef(false);

  const showError = (summary) => {
    if (toastShownRef.current) return;
    toastShownRef.current = true;
    onError?.(summary);
    setTimeout(() => { toastShownRef.current = false; }, 500);
  };

  const handleConfirmClick = () => {
    const regNumber = data?.registration_number?.trim?.() ?? "";
    if (!regNumber) {
      showError("El número de registro es obligatorio.");
      if (!onError) handleClose();
      return Promise.resolve();
    }
    setLoading(true);
    return new Promise((resolve) => {
      callActionApiAsync(
        () => checkImportRegistrationNumber(regNumber, data?.previous_id ?? null),
        async (res) => {
          const result = res?.data ?? res;
          if (result?.exists) {
            showError(
              "El número de registro ya está en uso (duplicado). Por favor use otro número."
            );
            setLoading(false);
            if (!onError) handleClose();
            resolve();
            return;
          }
          try {
            await onConfirm();
          } finally {
            setLoading(false);
            resolve();
          }
        },
        () => {
          showError(
            "No se pudo validar el número de registro. Puede deberse a un duplicado o a un error con el número ingresado."
          );
          setLoading(false);
          if (!onError) handleClose();
          resolve();
        },
        (loading) => setLoading(!!loading)
      );
    });
  };

  return (
    <>
      <Dialog
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="verification-modal-title"
    >
      <DialogContent>
        <b className="button_text ">{`Confirmar ${isEdit ? "edición" : "creación"} de registro de vigencia`}</b>
        <div className="IHContainer align-center mt-10">
          <img
            className="icon-verification mr-10"
            src={"/icons/verification_warn.png"}
            alt="icon"
          />
          <div className="VContainer">
            <p className="verification-modal-text m-0">
              <b>Número de Registro:</b> {data?.registration_number ?? ""}. <b>Producto:</b> {data?.product ?? ""}.
            </p>
            <p className="verification-modal-text">
              <b>Nueva Vigencia:</b> {data?.start_date} – {data?.end_date}
            </p>
            <b className="verification-modal-text" style={{ marginTop: 8 }}>
              ¿Desea confirmar y {isEdit ? "editar" : "crear"} estos cambios?
            </b>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <LaddaButton
          color="6A6AD8"
          backgroundColor={"white"}
          onClick={onCancel || handleClose}
        >
          <div className="HContainer align-center">
            <p className="button_text">{yesNo ? "No" : "Cancelar"}</p>
          </div>
        </LaddaButton>
        <LaddaButton
          variant="contained"
          onClick={handleConfirmClick}
          disabled={loading}
        >
          <div className="HContainer align-center">
            <p className="button_text">{yesNo ? "Si" : "Aceptar"}</p>
          </div>
        </LaddaButton>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default ForeignTradeVerificationModal;
